import React from 'react';
import PropTypes from 'prop-types';
import { ActionCableConsumer } from 'react-actioncable-provider';

export default class CableConnection extends React.Component {
  static propTypes = {
    message: PropTypes.string
  };

  constructor(...props) {
    super(...props);

    this.handleReceived = this.handleReceived.bind(this);

    this.state = {
      message: ''
    };
  }

  handleReceived(message) {
    localStorage.setItem("access_right", JSON.stringify(message))
    this.forceUpdate();

  }

  render() {
    return (
      <ActionCableConsumer
        channel="UserChannel"
        onReceived={this.handleReceived}
      >
      </ActionCableConsumer>
    );
  }
}